export default [
  {
    path: '/app/contacts',
    name: 'Contacts',
    component: () => import('@/views/Admin/Contacts/Index.vue'),
    meta: {
      pageTitle: 'İletişim',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_CONTACTS',
      action: 'read',
    },
  },
  {
    path: '/app/contacts/add',
    name: 'ContactAdd',
    component: () => import('@/views/Admin/Contacts/Add.vue'),
    meta: {
      pageTitle: 'İletişim',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/contacts',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_CONTACTS',
      action: 'read',
    },
  },
  {
    path: '/app/contacts/edit/:id',
    name: 'ContactEdit',
    component: () => import('@/views/Admin/Contacts/Edit.vue'),
    meta: {
      pageTitle: 'İletişim',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/contacts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_CONTACTS',
      action: 'read',
    },
  },
]
